import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import {
  ClassGradesView,
  classQueryOptions,
  groupGradesFilters
} from '@/modules/classes'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute(
  '/_auth/students-and-classes/classes/$classId/grades'
)({
  validateSearch: groupGradesFilters,
  component: ClassGradesView,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context, params }) => {
    const [semesters, { displayName }] = await Promise.all([
      context.queryClient.ensureQueryData(semesterQueryOptions({})),
      context.queryClient.ensureQueryData(classQueryOptions(params.classId))
    ])

    if (
      !search.semesterId ||
      !isSelectedSemesterInOptions(
        search.semesterId,
        semesters.semestersFromCurrentYearOptions
      )
    ) {
      throw redirect({
        replace: true,
        to: '/students-and-classes/classes/$classId/grades',
        params,
        search: {
          ...search,
          semesterId: semesters.currentSemester?.id
        }
      })
    }

    return displayName
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([
      loaderData,
      i18n.t('title.grades', { ns: 'classes' })
    ])
})
